import React from 'react';
import classes from './Response.module.scss';

import {connect} from "react-redux";

import Button from '../Button/Button';
import Aux from '../../hoc/Aux';

const response = ( props ) => {

    let QuestionsData = require( '../../data/' + props.mode + '-questions.js' );

    return (
        <Aux>
            <div className={classes.Response}>
                {props.response}
            </div>

            <Button onButtonClick={() => props.onButtonClick()} addClass={classes['BG-' + QuestionsData[props.version][props.currentItem].color_scheme]}>CONTINUE</Button>

        </Aux>
    );

};

const mapStateToProps = state => {
    return {
        mode: state.mode
    }
};

export default connect( mapStateToProps )( response );
